import {formActionTypes, formIds} from "../constants/ActionTypes";

const buildInitialStateForm = () => ({
  open: false,
  model: null,
  formData: {},
  isLoading: false
});

const initialState = {
  [formIds.SIZE]: buildInitialStateForm(),
};

const forms = (state = initialState, action) => {
  if (!action || !action.form) {
    return state;
  }

  const form = state[action.form] || {};

  switch (action.type) {
    case formActionTypes.HANDLE_OPEN:
      return {
        ...state,
        [action.form]: {
          ...form,
          open: true,
          model: action.data
        }
      };
    case formActionTypes.HANDLE_CLOSE:
      return {
        ...state,
        [action.form]: {
          ...form,
          ...buildInitialStateForm()
        }
      };
    case formActionTypes.HANDLE_CHANGE_FORM_DATA:
      return {
        ...state,
        [action.form]: {
          ...form,
          formData: {
            ...form.formData,
            [action.field]: action.value
          }
        }
      };
    case formActionTypes.IS_LOADING:
      return {
        ...state,
        [action.form]: {
          ...form,
          isLoading: action.data
        }
      };
    default: break;
  }

  return state;
};

export default forms;



// WEBPACK FOOTER //
// ./reducers/forms.reducers.js